import { useIntl } from "react-intl";
import { Link, useOutletContext } from "react-router-dom";
import { ReactComponent as GroupIconSVG } from "../../assets/group-icon-small.svg";
import { ReactComponent as PlusSVG } from "../../assets/plus-thin.svg";

import GroupInterface from "../../interfaces/GroupInterface";

import { MainPageOutletContext } from "../main/Main";
import "./device.scss";

function AddDevice({ group }: { group: GroupInterface }) {
  const { formatMessage } = useIntl();
  const outlet = useOutletContext<MainPageOutletContext>();

  return (
    <Link
      to={outlet.generatePath("/group/:groupId/device", { groupId: group.id })}
      className="create-device device-preview"
    >
      <div className="item icon">
        <GroupIconSVG />
      </div>

      <div className="item description">
        <div className="title">
          {formatMessage({ id: "group.create_device" })}
        </div>
      </div>

      <div className="item settings">
        <PlusSVG />
      </div>
    </Link>
  );
}

export default AddDevice;
